type ConfirmHandler = (title: string, description: string) => Promise<boolean>;
let handler: ConfirmHandler | null = null;

export function registerConfirmHandler(h: ConfirmHandler) {
  handler = h;
}

export function confirm(title: string, description: string): Promise<boolean> {
  return handler
    ? handler(title, description)
    : Promise.resolve(window.confirm(`${title}\n\n${description}`));
}
